module.exports = __webpack_public_path__ + "Flag-136.89a2c9af8ef4c649ad0d572b58ff648a.svg";